import { useRootStore } from "@/state/RootStore";
import posthog, { captureEvent } from "@/utils/posthog";
import { useClerk } from "@clerk/clerk-react";
import { clearClerkSession } from "@/lib/useAuthedFetch";
import { clearUserScopedStorage } from "@/utils/storage";

export const useLogout = () => {
  const store = useRootStore();
  const { signOut } = useClerk();

  const handleSignOut = async () => {
    captureEvent("log_out_click");

    store.mainAppStore.profileSaved = false;
    store.mainAppStore.clearEmailPreferencesCache();

    // Storage keys are not namespaced by user, so anything left behind is
    // adopted by the next account to sign in on this browser — most visibly an
    // unfinished exam, which Study auto-restores and navigates straight into.
    // Cleared before signOut() so it still happens if sign-out navigates away.
    // In-memory store state is already reset by the auth-transition handler in
    // App.tsx; resetting again here would re-trigger its loaders after sign-out.
    clearUserScopedStorage();

    // Reset PostHog identification before signing out
    posthog.reset();

    await signOut();
    clearClerkSession();
  };

  return { handleSignOut };
};
